import { gql } from "@apollo/client";

export interface ISendProfileMessageVars {
  profileId: string;
  message: string;
}

export const SEND_PROFILE_MESSAGE = gql`
  mutation sendProfileMessage($profileId: String!, $message: String!) {
    sendProfileMessage(profileId: $profileId, message: $message) {
      delivered
    }
  }
`;
